var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-btn",
    { attrs: { small: "", flat: "", color: "iconColor" } },
    [_c("q-icon", { attrs: { name: _vm.booleanIcon, color: _vm.iconColor } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }